
import {
    HABITATESTRATO_LOADING,
    HABITATESTRATO_LOADED,
    HABITATESTRATO_ERROR,

    TIPOHABITAT_LOADING,
    TIPOHABITAT_LOADED,
    TIPOHABITAT_ERROR,

    COLORESPECIE_LOADING,
    COLORESPECIE_LOADED,
    COLORESPECIE_ERROR,
    
    ESPECIESIMILITUD_LOADING,
    ESPECIESIMILITUD_LOADED,
    ESPECIESIMILITUD_ERROR,

    SELECTREINO_LOADING,
    SELECTREINO_LOADED,
    SELECTREINO_ERROR,

    SELECTFILO_LOADING,
    SELECTFILO_LOADED,
    SELECTFILO_ERROR,

    SELECTSUBFILO_LOADING,
    SELECTSUBFILO_LOADED,
    SELECTSUBFILO_ERROR,

    SELECTCLASE_LOADING,
    SELECTCLASE_LOADED,
    SELECTCLASE_ERROR,

    SELECTINFRACLASE_LOADING,
    SELECTINFRACLASE_LOADED,
    SELECTINFRACLASE_ERROR,

    SELECTORDEN_LOADING,
    SELECTORDEN_LOADED,
    SELECTORDEN_ERROR,

    SELECTSUBORDEN_LOADING,
    SELECTSUBORDEN_LOADED,
    SELECTSUBORDEN_ERROR,

    SELECTFAMILIA_LOADING,
    SELECTFAMILIA_LOADED,
    SELECTFAMILIA_ERROR,

    SELECTSUBFAMILIA_LOADING,
    SELECTSUBFAMILIA_LOADED,
    SELECTSUBFAMILIA_ERROR,

    SELECTRIBU_LOADING,
    SELECTRIBU_LOADED,
    SELECTRIBU_ERROR,

    SELECTGENERO_LOADING,
    SELECTGENERO_LOADED,
    SELECTGENERO_ERROR,

    SELECTFICHA_LOADING,
    SELECTFICHA_LOADED,
    SELECTFICHA_ERROR,

    FILTROSELECT_LOADING,
    FILTROSELECT_LOADED,
    FILTROSELECT_ERROR,

    ENDEMISMO_LOADING,
    ENDEMISMO_LOADED,
    ENDEMISMO_ERROR,

    ESPECIEFICHASIMILITUD_LOADING,
    ESPECIEFICHASIMILITUD_LOADED,
    ESPECIEFICHASIMILITUD_ERROR,
  } from './../../types/extratypes';

import {
    USERSELECT_LOAD,
    USERSELECT_LOADING,
    USERSELECT_ERROR,
} from './../../types/usertypes';

const INITIAL_STATE = {
    isLoading: false,
    isendemismoLoading: false,
    errorendemismo: '',
    filtro: null,
    user: [],
    ficha: null,
    tipo: null,
    color: null,
    especieficha:null,
    especiesimilitud: null,
    reino: null,
    filo: null,
    subfilo: null,
    clase: null,
    infraclase: null,
    orden: null,
    suborden: null,
    familia: null,
    subfamilia: null,
    tribu: null,
    genero: null,
    habitat: null,
    endemismo:null,
    error: '',
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case ESPECIEFICHASIMILITUD_LOADING:
            return {
                ... state,
                isLoading : true,
                especieficha: null,
                error: ''
            }
        case ESPECIEFICHASIMILITUD_LOADED:
            return {
                ...state,
                especieficha: action.payload,
                isLoading : false,
                error: ''
            }
        case ESPECIEFICHASIMILITUD_ERROR:
            return {
                ...state,
                especieficha: null,
                isLoading : false,
                error: action.payload,
            }

        case ENDEMISMO_LOADING:
            return {
                ... state,
                isendemismoLoading : true,
                endemismo: null,
                errorendemismo: ''
            }
        case ENDEMISMO_LOADED:
            return {
                ...state,
                endemismo: action.payload,
                isLoading : false,
                error: ''
            }
        case ENDEMISMO_ERROR:
            return {
                ...state,
                endemismo: null,
                isLoading : false,
                error: action.payload,
            }

        case FILTROSELECT_LOADING:
            return {
                ... state,
                isLoading : true,
                filtro: null,
                error: ''
            }
        case FILTROSELECT_LOADED:
            return {
                ...state,
                filtro: action.payload,
                isLoading : false,
                error: ''
            }
        case FILTROSELECT_ERROR:
            return {
                ...state,
                filtro: null,
                isLoading : false,
                error: action.payload,
            }

        case USERSELECT_LOADING:
            return {
                ... state,
                isLoading : true,
                user: [],
                error: ''
            }
        case USERSELECT_LOAD:
            return {
                ...state,
                user: action.payload,
                isLoading : false,
                error: ''
            }
        case USERSELECT_ERROR:
            return {
                ...state,
                user: [],
                isLoading : false,
                error: action.payload,
            }

        case SELECTFICHA_LOADING:
            return {
                ... state,
                isLoading : true,
                ficha: null,
                error: ''
            }
        case SELECTFICHA_LOADED:
            return {
                ...state,
                ficha: action.payload,
                isLoading : false,
                error: ''
            }
        case SELECTFICHA_ERROR:
            return {
                ...state,
                ficha: null,
                isLoading : false,
                error: action.payload,
            }

        case HABITATESTRATO_LOADING:
            return {
                ... state,
                isLoading : true
            }
        case HABITATESTRATO_LOADED:
            return {
                ...state,
                habitat: action.payload
            };
        case HABITATESTRATO_ERROR:
            return {
                ...state,
                error: action.payload,
            }

        case TIPOHABITAT_LOADING:
            return {
                ... state,
                isLoading : true
            }
        case TIPOHABITAT_LOADED:
            return {
                ...state,
                tipo: action.payload
            };
        case TIPOHABITAT_ERROR:
            return {
                ...state,
                error: action.payload,
            }

        case COLORESPECIE_LOADING:
            return {
                ... state,
                isLoading : true
            }
        case COLORESPECIE_LOADED:
            return {
                ...state,
                color: action.payload
            };
        case COLORESPECIE_ERROR:
            return {
                ...state,
                error: action.payload,
            }

        case ESPECIESIMILITUD_LOADING:
            return {
                ... state,
                isLoading : true
            }
        case ESPECIESIMILITUD_LOADED:
            return {
                ...state,
                especiesimilitud: action.payload
            };
        case ESPECIESIMILITUD_ERROR:
            return {
                ...state,
                error: action.payload,
            }

        case SELECTREINO_LOADING:
            return {
                ... state,
                isLoading : true,
                reino: null,
                error: ''
            }
        case SELECTREINO_LOADED:
            return {
                ...state,
                reino: action.payload,
                isLoading : false,
                error: ''
            };
        case SELECTREINO_ERROR:
            return {
                ...state,
                reino: null,
                isLoading : false,
                error: action.payload,
            }

        case SELECTFILO_LOADING:
            return {
                ... state,
                isLoading : true,
                filo: null,
                error: ''
            }
        case SELECTFILO_LOADED:
            return {
                ...state,
                filo: action.payload,
                isLoading : false,
                error: ''
            };
        case SELECTFILO_ERROR:
            return {
                ...state,
                filo: null,
                isLoading : false,
                error: action.payload,
            }

        case SELECTSUBFILO_LOADING:
            return {
                ... state,
                isLoading : true,
                subfilo: null,
                error: ''
            }
        case SELECTSUBFILO_LOADED:
            return {
                ...state,
                subfilo: action.payload,
                isLoading : false,
                error: ''
            };
        case SELECTSUBFILO_ERROR:
            return {
                ...state,
                subfilo: null,
                isLoading : false,
                error: action.payload,
            }
        
        case SELECTCLASE_LOADING:
            return {
                ... state,
                isLoading : true,
                clase: null,
                error: ''
            }
        case SELECTCLASE_LOADED:
            return {
                ...state,
                clase: action.payload,
                isLoading : false,
                error: ''
            }
        case SELECTCLASE_ERROR:
            return {
                ...state,
                clase: null,
                isLoading : false,
                error: action.payload,
            }
        
        case SELECTINFRACLASE_LOADING:
            return {
                ... state,
                isLoading : true,
                infraclase: null,
                error: ''
            }
        case SELECTINFRACLASE_LOADED:
            return {
                ...state,
                infraclase: action.payload,
                isLoading : false,
                error: ''
            }
        case SELECTINFRACLASE_ERROR:
            return {
                ...state,
                infraclase: null,
                isLoading : false,
                error: action.payload,
            }

        case SELECTORDEN_LOADING:
            return {
                ... state,
                isLoading : true,
                orden: null,
                error: ''
            }
        case SELECTORDEN_LOADED:
            return {
                ...state,
                orden: action.payload,
                isLoading : false,
                error: ''
            }
        case SELECTORDEN_ERROR:
            return {
                ...state,
                orden: null,
                isLoading : false,
                error: action.payload,
            }
        
        case SELECTSUBORDEN_LOADING:
            return {
                ... state,
                isLoading : true,
                suborden: null,
                error: ''
            }
        case SELECTSUBORDEN_LOADED:
            return {
                ...state,
                suborden: action.payload,
                isLoading : false,
                error: ''
            }
        case SELECTSUBORDEN_ERROR:
            return {
                ...state,
                suborden: null,
                isLoading : false,
                error: action.payload,
            }
        
        case SELECTFAMILIA_LOADING:
            return {
                ... state,
                isLoading : true,
                familia: null,
                error: ''
            }
        case SELECTFAMILIA_LOADED:
            return {
                ...state,
                familia: action.payload,
                isLoading : false,
                error: ''
            }
        case SELECTFAMILIA_ERROR:
            return {
                ...state,
                familia: null,
                isLoading : false,
                error: action.payload,
            }

        case SELECTSUBFAMILIA_LOADING:
            return {
                ... state,
                isLoading : true,
                subfamilia: null,
                error: ''
            }
        case SELECTSUBFAMILIA_LOADED:
            return {
                ...state,
                subfamilia: action.payload,
                isLoading : false,
                error: ''
            }
        case SELECTSUBFAMILIA_ERROR:
            return {
                ...state,
                subfamilia: null,
                isLoading : false,
                error: action.payload,
            }

        case SELECTRIBU_LOADING:
            return {
                ... state,
                isLoading : true,
                tribu: null,
                error: ''
            }
        case SELECTRIBU_LOADED:
            return {
                ...state,
                tribu: action.payload,
                isLoading : false,
                error: ''
            }
        case SELECTRIBU_ERROR:
            return {
                ...state,
                tribu: null,
                isLoading : false,
                error: action.payload,
            }            
        
        case SELECTGENERO_LOADING:
            return {
                ... state,
                isLoading : true,
                genero: null,
                error: ''
            }
        case SELECTGENERO_LOADED:
            return {
                ...state,
                genero: action.payload,
                isLoading : false,
                error: ''
            }
        case SELECTGENERO_ERROR:
            return {
                ...state,
                genero: null,
                isLoading : false,
                error: action.payload,
            }  
        
        default: return state;
    }
}